var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "191px",
    height: "191px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.4251207729468599s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(15.652173913043478 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.4057971014492754s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(31.304347826086957 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.3864734299516908s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(46.95652173913044 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.3671497584541063s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(62.608695652173914 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.34782608695652173s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(78.26086956521739 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.3285024154589372s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(93.91304347826087 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.30917874396135264s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(109.56521739130434 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.2898550724637681s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(125.21739130434783 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.27053140096618356s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(140.8695652173913 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.25120772946859904s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(156.52173913043478 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.2318840579710145s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(172.17391304347825 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.21256038647342995s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(187.82608695652175 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.1932367149758454s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(203.47826086956522 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.17391304347826086s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(219.1304347826087 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.15458937198067632s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(234.7826086956522 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.13526570048309178s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(250.43478260869566 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.11594202898550725s",
    repeatCount: "indefinite"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(266.0869565217391 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.0966183574879227s",
    repeatCount: "indefinite"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(281.7391304347826 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.07729468599033816s",
    repeatCount: "indefinite"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(297.39130434782606 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.057971014492753624s",
    repeatCount: "indefinite"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(313.04347826086956 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.03864734299516908s",
    repeatCount: "indefinite"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(328.69565217391306 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "-0.01932367149758454s",
    repeatCount: "indefinite"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(344.3478260869565 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8,
    rx: 0,
    ry: 0,
    width: 1,
    height: 24,
    fill: "#1d0e0b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.4444444444444444s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.1bb3ee461e236231914ef7a7f456097f.svg";
export { ForwardRef as ReactComponent };